const CURRENCY_SYMBOLS = { UYU: '$U', ARS: '$AR' }

const CURRENCY_TIME_ZONES = {
  UYU: { locale: 'es-UY', timeZone: 'America/Montevideo' },
  ARS: { locale: 'es-AR', timeZone: 'America/Argentina/Buenos_Aires' }
}

export const currencySymbol = currency => CURRENCY_SYMBOLS[currency] || '$'

export const toFiniteAmount = amount => {
  if (amount === null || amount === undefined || amount === '') return null
  const value = Number(amount)
  return Number.isFinite(value) ? value : null
}

const toValidDate = value => {
  if (!value) return null
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? null : date
}

const zoneOf = currency => CURRENCY_TIME_ZONES[currency] || CURRENCY_TIME_ZONES.UYU

export const formatInstant = (value, currency) => {
  const date = toValidDate(value)
  if (!date) return null
  const { locale, timeZone } = zoneOf(currency)
  return new Intl.DateTimeFormat(locale, {
    timeZone,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23'
  }).format(date)
}

const withoutAbbreviationDot = value => value.replace(/\.$/, '')

export const formatCompactInstant = (value, currency) => {
  const date = toValidDate(value)
  if (!date) return null
  const { locale, timeZone } = zoneOf(currency)
  const parts = new Intl.DateTimeFormat(locale, {
    timeZone,
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23'
  }).formatToParts(date)
  const part = type => withoutAbbreviationDot(parts.find(item => item.type === type)?.value ?? '')
  return `${part('weekday')} ${part('day')} ${part('month')}, ${part('hour')}:${part('minute')}`
}

export default function formatMoney(amount, currency) {
  const value = toFiniteAmount(amount)
  if (value === null) return null
  return `${currencySymbol(currency)} ${value.toLocaleString('es-AR', { maximumFractionDigits: 2 })}`
}
